import React from "react";
import { Container, Row } from "react-bootstrap";
// used for making the prop types of this component
import PropTypes from "prop-types";
import Link from "@mui/material/Link";

function Footer(props) {
  return (
    <footer className={"footer" + (props.default ? " footer-default" : "")}>
      <Container fluid={props.fluid ? true : false}>
        <Row>
          <div className="credits ml-auto">
            <div className="copyright">
              &copy; {1900 + new Date().getYear()}, made with{" "}
              <i className="fa fa-heart heart" />{" "}by{" "}
              <Link href="https://talentyhire.com/" color="inherit">
                Talenty-Hire
              </Link>
            </div>
          </div>
        </Row>
      </Container>
    </footer>
  );
}

Footer.propTypes = {
  default: PropTypes.bool,
  fluid: PropTypes.bool,
};

export default Footer;
